import React, { useEffect, useState } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { SELECTION_ALL } from '../../common/constants';

const LimitDropdown = ({
    selectedCompany,
    selectedDevice,
    limit,
    setLimit
}) => {
    const { t } = useTranslation();
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const isAllSelected = (val) => !val || val === SELECTION_ALL;
    const showAllOption = !isAllSelected(selectedCompany) && !isAllSelected(selectedDevice);

    const options = showAllOption
        ? [20, 50, SELECTION_ALL]
        : [20, 50];

    const handleSelect = (value) => {
        setLimit(value);
        setDropdownOpen(false);
    };

    // Effect to reset limit if "ALL" is no longer a valid option
    useEffect(() => {
        if (!showAllOption && limit === SELECTION_ALL) {
            setLimit(20);
        }
        // eslint-disable-next-line
    }, [selectedCompany, selectedDevice, showAllOption, limit]);

    return (
        <Dropdown isOpen={dropdownOpen} toggle={() => setDropdownOpen(!dropdownOpen)}>
            <DropdownToggle color="primary" caret className="mb-2 me-2 ms-2">
                {t(`PageAdmin.CompanyDeviceRecordTable.Limit.${limit}`)}
            </DropdownToggle>
            <DropdownMenu>
                {options.map(opt => (
                    <DropdownItem
                        key={opt}
                        active={limit === opt}
                        onClick={() => handleSelect(opt)}
                    >
                        {t(`PageAdmin.CompanyDeviceRecordTable.Limit.${opt}`)}
                    </DropdownItem>
                ))}
            </DropdownMenu>
        </Dropdown>
    );
};

export default LimitDropdown;
